export default {
  root: '/workspace',
  create: '/workspace/create',
  customize: '/workspace/customize',
} as const;
